import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const PayerPage = () => {
  const columns = [
    { key: 'name', label: 'Payer Name' },
    { key: 'payerId', label: 'Payer ID' },
    { key: 'type', label: 'Type' },
    { key: 'phone', label: 'Phone' },
    { key: 'electronicId', label: 'Electronic ID' },
    { key: 'filingDays', label: 'Filing Days' },
    { key: 'active', label: 'Active' },
  ];

  const initialData = [
    { id: '1', name: 'Medicare Part A', payerId: 'MED-A', type: 'Medicare', phone: '1-800-633-4227', electronicId: '00521', filingDays: '365', active: 'Yes' },
    { id: '2', name: 'Medicare Part B', payerId: 'MED-B', type: 'Medicare', phone: '1-800-633-4227', electronicId: '00521', filingDays: '365', active: 'Yes' },
    { id: '3', name: 'Texas Medicaid', payerId: 'TXMCD', type: 'Medicaid', phone: '1-800-252-8263', electronicId: 'TXMCD', filingDays: '95', active: 'Yes' },
    { id: '4', name: 'UnitedHealthcare', payerId: 'UHC001', type: 'Commercial', phone: '1-800-328-5979', electronicId: '87726', filingDays: '180', active: 'Yes' },
    { id: '5', name: 'Aetna', payerId: 'AETNA', type: 'Commercial', phone: '1-800-872-3862', electronicId: '60054', filingDays: '180', active: 'Yes' },
    { id: '6', name: 'Blue Cross Blue Shield TX', payerId: 'BCBSTX', type: 'Commercial', phone: '1-800-521-2227', electronicId: '84980', filingDays: '180', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Payer"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Payer"
    />
  );
};

export default PayerPage;
